import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';
import { ENDPOINT_FIND_RESPONSER_METHOD } from './constants';

export function useParamSystemService() {
  const { backendGet } = Sebrae.useBackend();

  const getRequestMethodByInterview = React.useCallback(
    (idInterview) =>
      backendGet(
        `${ENDPOINT_FIND_RESPONSER_METHOD}/${idInterview}/responser-method`,
      ),
    [backendGet],
  );

  return { getRequestMethodByInterview };
}
